import { PaymentMethod } from "../../../../common/enums";
export const PAYMENT_INSTRUCTIONS_LABEL: Record<PaymentMethod, string> = {
  [PaymentMethod.Wire]: "wire transfer",
  [PaymentMethod.ACH]: "ACH direct deposit",
  [PaymentMethod.Check]: "check",
};
